export const SIDE_NAV_COLLAPSED_WIDTH = 72
export const HEADER_HEIGHT = 72
export const SIDE_NAV_LIGHT = 'SIDE_NAV_LIGHT'
export const NAV_TYPE_SIDE = 'SIDE'
export const DIR_LTR = 'ltr'
